import $ from 'jquery';
import { triggerEvent } from '../../util/dom.js';

const getWidget = (/** @type {JQuery} */ $element) => {
	let $compoundParent;
	// This is an option inside a single selection/choice group
	if ($element.hasClass('form__single-choice-option-input') && ($compoundParent = $element.closest('.form__single-choice, .form__single-selection')) && ($compoundParent.length > 0)) {
		return $compoundParent;
	}
	return $element;
};

/**
 * Forward custom form events
 *
 * @param {JQuery<HTMLElement>|HTMLElement} container
 *
 * @returns {void}
 */
mpro.handleCustomFormEvents = (container) => {

	/** @type {JQuery} */
	// @ts-ignore
	const $container = (container instanceof $) ? container : $(container);
	const eventNs = 'mp:form';

	for (const form of $container.find('form')) {

		const $form = $(form);

		$form.on({
			'change.custom-form-handler': (e) => {
				const {
					currentTarget: form,
					target,
				} = e;
				/** @type {JQuery} */// @ts-ignore
				const $target = $(target);
				const value = $target.val();
				const widget = getWidget($target)[0];

				// console.log('triggerEvent', `${eventNs}:${widget.id}:change`, { detail: { form, target, value, widget } });
				// @ts-ignore
				triggerEvent(document, `${eventNs}:${widget.id}:change`, { detail: { form, target, value, widget } });
			},
			'submit.custom-form-handler': (e) => {
				const {
					currentTarget: form,
					target,
				} = e;
				/** @type {JQuery} */// @ts-ignore
				const $target = $(target);
				// @ts-ignore
				const formData = new FormData(form);
				const widget = getWidget($target)[0];

				// console.log('triggerEvent', `${eventNs}:${widget.id}:submit`, { detail: { form, target, widget, formData } });
				// @ts-ignore
				const evt = triggerEvent(document, `${eventNs}:${widget.id}:submit`, { detail: { form, target, widget, formData } });

				// TODO: implement the `advance()` method on the `event.detail` so the user can control the form submission flow later
				if (evt.defaultPrevented) {
					e.preventDefault();
					e.stopPropagation();
					e.stopImmediatePropagation();
				}
			},
		});
	}
};

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {
	mpro.handleCustomFormEvents($container);
});

export default mpro;
